var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _rect2, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiyaPrecision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 696.29 144.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1100b1;}.cls-2{fill:#00dee5;}.cls-3{fill:#313894;}.cls-4{fill:#51c4d2;}.cls-5{fill:#b42fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Miya") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.41,44.53a1,1,0,0,1,1.09-.91h1a1.11,1.11,0,0,1,1,.6l13.34,28.63H191l13.35-28.63a1,1,0,0,1,1-.6h1a1,1,0,0,1,1.09.91l7.15,40.75a1.05,1.05,0,0,1-1.09,1.4H208a1.32,1.32,0,0,1-1.15-.91l-3.58-23h-.18L192.48,86.62a1,1,0,0,1-1,.66h-1.09a1.11,1.11,0,0,1-1-.66L178.59,62.78h-.18l-3.52,23a1.18,1.18,0,0,1-1.09.91h-5.46a1.11,1.11,0,0,1-1.15-1.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.35,45.38a1.19,1.19,0,0,1,1.15-1.16h5.64a1.19,1.19,0,0,1,1.15,1.16V85.52a1.19,1.19,0,0,1-1.15,1.16H228.5a1.19,1.19,0,0,1-1.15-1.16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.24,66.24,245.41,46a1.12,1.12,0,0,1,1-1.76h6.18a1.2,1.2,0,0,1,1,.55l9.71,13.95,9.7-13.95a1.22,1.22,0,0,1,1-.55h6.25a1.12,1.12,0,0,1,1,1.76l-14,20.2V85.52A1.2,1.2,0,0,1,266,86.68h-5.58a1.15,1.15,0,0,1-1.15-1.16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.19,85.1l18.86-40.82a1.08,1.08,0,0,1,1-.66h.61a1,1,0,0,1,1,.66L321.4,85.1a1.07,1.07,0,0,1-1,1.58h-5.28a1.75,1.75,0,0,1-1.76-1.22l-3-6.55H292.23l-3,6.55a1.81,1.81,0,0,1-1.75,1.22h-5.28A1.07,1.07,0,0,1,281.19,85.1Zm26.2-12.92-6.07-13.34h-.18L295.2,72.18Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.45,45.38a1.15,1.15,0,0,1,1.15-1.16h14.25a13.53,13.53,0,1,1,.06,27.05h-7.58V85.52a1.19,1.19,0,0,1-1.15,1.16H353.6a1.15,1.15,0,0,1-1.15-1.16Zm14.92,18.49a6.25,6.25,0,0,0,6.24-6.3,6.05,6.05,0,0,0-6.24-5.89h-7V63.87Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.41,45.38a1.16,1.16,0,0,1,1.15-1.16h17.35a13.14,13.14,0,0,1,13.22,13c0,5.58-3.7,10.13-9,12.25l8.31,15.41a1.15,1.15,0,0,1-1,1.76h-6.37a1.06,1.06,0,0,1-1-.55L407,70.06H400.3V85.52a1.2,1.2,0,0,1-1.16,1.16h-5.58a1.16,1.16,0,0,1-1.15-1.16Zm17.83,18.19a6.18,6.18,0,0,0,6-6.19,6,6,0,0,0-6-5.88h-9.88V63.57Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M437.31,45.38a1.15,1.15,0,0,1,1.15-1.16h24.68a1.16,1.16,0,0,1,1.16,1.16v5a1.16,1.16,0,0,1-1.16,1.15H445.19v10h15a1.18,1.18,0,0,1,1.15,1.15v5a1.15,1.15,0,0,1-1.15,1.16h-15V79.4h17.95a1.15,1.15,0,0,1,1.16,1.15v5a1.16,1.16,0,0,1-1.16,1.16H438.46a1.15,1.15,0,0,1-1.15-1.16Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M495.73,43.62a20.55,20.55,0,0,1,14.68,5.64,1.13,1.13,0,0,1,.06,1.69l-3.7,3.83a1,1,0,0,1-1.52,0,14.32,14.32,0,0,0-9.34-3.58c-7.76,0-13.52,6.49-13.52,14.13a13.73,13.73,0,0,0,13.58,14,14.57,14.57,0,0,0,9.28-3.46,1.13,1.13,0,0,1,1.52,0l3.76,3.88a1.17,1.17,0,0,1-.06,1.64,20.84,20.84,0,0,1-14.74,5.88,21.83,21.83,0,1,1,0-43.66Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M522.57,45.38a1.19,1.19,0,0,1,1.15-1.16h5.64a1.19,1.19,0,0,1,1.15,1.16V85.52a1.19,1.19,0,0,1-1.15,1.16h-5.64a1.19,1.19,0,0,1-1.15-1.16Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M543.71,80.73,545.89,77a1.4,1.4,0,0,1,2.06-.42c.31.18,5.22,3.76,9.16,3.76,3.16,0,5.52-2.06,5.52-4.67,0-3.09-2.61-5.22-7.7-7.28-5.7-2.3-11.4-5.94-11.4-13.1,0-5.4,4-11.64,13.64-11.64a21.33,21.33,0,0,1,12.13,4.06,1.5,1.5,0,0,1,.37,2l-2.31,3.46a1.59,1.59,0,0,1-2.12.73c-.49-.31-5.1-3.34-8.43-3.34s-5.34,2.3-5.34,4.25c0,2.85,2.25,4.79,7.16,6.79,5.88,2.36,12.67,5.88,12.67,13.7,0,6.25-5.39,12-13.95,12-7.64,0-12.12-3.58-13.34-4.73C543.47,82,543.16,81.7,543.71,80.73Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M583.77,45.38a1.2,1.2,0,0,1,1.15-1.16h5.64a1.2,1.2,0,0,1,1.16,1.16V85.52a1.2,1.2,0,0,1-1.16,1.16h-5.64a1.2,1.2,0,0,1-1.15-1.16Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M626,43.62a21.83,21.83,0,1,1-21.77,21.89A21.79,21.79,0,0,1,626,43.62Zm0,35.78a14,14,0,1,0-13.89-13.89A14,14,0,0,0,626,79.4Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M660.45,44.71a1.14,1.14,0,0,1,1.15-1.09h1.52l25.23,26.8h.06v-25a1.15,1.15,0,0,1,1.15-1.16h5.58a1.19,1.19,0,0,1,1.15,1.16V86.19a1.13,1.13,0,0,1-1.15,1.09h-1.45L668.33,59.45h-.06V85.52a1.15,1.15,0,0,1-1.15,1.16H661.6a1.2,1.2,0,0,1-1.15-1.16Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 76.28,
    y: 88.05,
    width: 47.05,
    height: 47.05,
    transform: "translate(-49.66 103.25) rotate(-45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.74,
    y: 88.05,
    width: 47.05,
    height: 47.05,
    transform: "translate(-69.15 56.2) rotate(-45)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.8,78.29l-.35.37.36-.36Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.27,78.3l.34.34-.33-.34Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.45,78.66l-.5.5C99.12,79,99.29,78.83,99.45,78.66Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.14,79.17l-.53-.53Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.8,78.29A46.21,46.21,0,1,0,20.33,46.23h0a46.08,46.08,0,0,0,13,32.07L66.54,45Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.54,45,33.28,78.3l.33.34.53.53,32.4,32.4L99,79.16l.5-.5.35-.37Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiyaPrecision);
export default __webpack_public_path__ + "static/media/MiyaPrecision.c8ebf862d1d59d8b37324fcd72f6f5cd.svg";
export { ForwardRef as ReactComponent };